import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import "../Features.css";
import WaitingFor from "components/Banner/WaitingFor";
import { ReactComponent as BgLeft } from "images/background/hero-section-left-triangle.svg";
import { ReactComponent as BgRight } from "images/background/left-box-graphic.svg";
import { ReactComponent as RedShadow } from "images/background/software-solution-graphic-red.svg";
import { getData } from "app/data";
import { FormattedMessage } from "react-intl";
import { formatText } from "util/helper";
import { Link } from "react-router-dom";

export default function Index() {
  const tab = ["business", "consumer"];
  const [contents, setContents] = useState(tab[0]);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", function (e) {
      toggleVisibility();
    });
    return () => window.removeEventListener("scroll", toggleVisibility());
  }, []);
  const toggleVisibility = () => {
    if (window.pageYOffset > 400) {
      setIsFixed(true);
    } else {
      setIsFixed(false);
    }
  };

  return (
    <div className="features">
      <div className="page-header">
        <div className="contents">
          <BgLeft className="features-bg-left" />
          <BgRight className="features-bg-right" />
          <RedShadow className="page-header-bg-right-shadow" />
          <div className="text">
            <h2>{getData("features").header.title}</h2>
            <p>{getData("features").header.text}</p>
          </div>
          <div className="green-button">
            <Link to="/request-a-demo">
              <FormattedMessage id="request_a_demo" />
            </Link>
          </div>
          <div className={`tab ${isFixed ? "fixed" : null}`}>
            <ul>
              {tab.map((item) => (
                <li className={contents === item ? "selected" : null}>
                  <Link
                    to={
                      item === "business"
                        ? "/features-business"
                        : "/features-consumer"
                    }
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="background">
        <div className="contents">
          {getData("features")
            ? getData("features")[contents].map((item, index) => (
                <>
                  <div
                    className={`title ${
                      index % 2 === 0 ? "primary" : "accent"
                    }`}
                  >
                    <item.iconUrl />
                    <h2>{item.title}</h2>
                  </div>
                  <div className="row">
                    {item.contents.map((childItem) => (
                      <>
                        <div className="col-lg-6 col-sm-12">
                          <div className="card">
                            <div className="table-cell">
                              <div className="card-inner">
                                <h5 className="card-title">
                                  {childItem.title}{" "}
                                  <span className="gray">
                                    {childItem.coming ? (
                                      <FormattedMessage id="coming_soon" />
                                    ) : null}
                                  </span>
                                </h5>
                                <p className="card-text">{childItem.text}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                  {index < getData("features")[contents].length - 1 ? (
                    <hr />
                  ) : null}
                </>
              ))
            : null}
        </div>
      </div>
      <WaitingFor />
    </div>
  );
}
